export class Service {
  service_id: number;
  label: string;
}
